import React, { Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Loader from './components/Loader';
import Navbar from './components/Navbar';
import HowItWorksWidget from './components/HowItWorksWidget';
import SubmitterDetailsModal from './components/SubmitterDetailsModal';

const OSHMLanding = React.lazy(() => import('./pages/OSHMLanding'));
const OSHM = React.lazy(() => import('./pages/OSHM'));
const BuildingAssessment = React.lazy(() => import('./pages/BuildingAssessment'));
const DemoAssessment = React.lazy(() => import('./pages/DemoAssessment'));
const BasicAssessmentGuide = React.lazy(() => import('./pages/BasicAssessmentGuide'));
const AdvancedAssessmentGuide = React.lazy(() => import('./pages/AdvancedAssessmentGuide'));
const BasicBuildingLanding = React.lazy(() => import('./pages/BasicBuildingLanding'));
const ContactUs = React.lazy(() => import('./pages/ContactUs'));
const BasicBridgeLanding = React.lazy(() => import('./pages/BasicBridgeLanding'));
const CompositeBridgeAssessment = React.lazy(() => import('./pages/CompositeBridgeAssessment'));
const MasonryBridgeAssessment = React.lazy(() => import('./pages/MasonryBridgeAssessment'));
const RCCBridgeAssessment = React.lazy(() => import('./pages/RCCBridgeAssessment'));
const PSCBridgeAssessment = React.lazy(() => import('./pages/PSCBridgeAssessment'));
const SteelBridgeAssessment = React.lazy(() => import('./pages/SteelBridgeAssessment'));
const TunnelAssessment = React.lazy(() => import('./pages/TunnelAssessment'));
const LoadBearingAssessment = React.lazy(() => import('./pages/LoadBearingAssessment'));
const PaymentPage = React.lazy(() => import('./pages/PaymentPage'));
const Login = React.lazy(() => import('./pages/Login'));
const Signup = React.lazy(() => import('./pages/Signup'));
const ManageProfile = React.lazy(() => import('./pages/ManageProfile'));
const UserReports = React.lazy(() => import('./pages/UserReports'));
const AdminLogin = React.lazy(() => import('./pages/AdminLogin'));
const AdminDashboard = React.lazy(() => import('./pages/AdminDashboard'));
const AdvancedRCCBuilding = React.lazy(() => import('./pages/AdvancedRCCBuilding'));
const AdvancedLBBuilding = React.lazy(() => import('./pages/AdvancedLBBuilding'));
const AdvancedSteelBuilding = React.lazy(() => import('./pages/AdvancedSteelBuilding'));
const AdvancedCompositeBuilding = React.lazy(() => import('./pages/AdvancedCompositeBuilding'));
const AdvancedHeritageBuilding = React.lazy(() => import('./pages/AdvancedHeritageBuilding'));
const AssessmentReport = React.lazy(() => import('./pages/AssessmentReport'));
const PhysicalInspection = React.lazy(() => import('./pages/expert/PhysicalInspection'));
const StructuralDesignValidation = React.lazy(() => import('./pages/expert/StructuralDesignValidation'));
const NDT = React.lazy(() => import('./pages/expert/NDT'));
const LoadTest = React.lazy(() => import('./pages/expert/LoadTest'));
const SHM = React.lazy(() => import('./pages/expert/SHM'));

function App() {
  return (
    <Router basename={process.env.PUBLIC_URL}>
      <div className="App min-h-screen bg-gray-50">
        <Navbar />
        <HowItWorksWidget />
        <SubmitterDetailsModal />
        <main id="main-content">
        <Suspense fallback={<Loader />}>
          <Routes>
            <Route path="/" element={<OSHMLanding />} />
            <Route path="/oshm" element={<OSHMLanding />} />
            <Route path="/oshm-assessment" element={<OSHM />} />
            <Route path="/building-assessment-intro" element={<BasicBuildingLanding />} />
            <Route path="/building-assessment" element={<BuildingAssessment />} />
            <Route path="/demo-assessment" element={<DemoAssessment />} />
            <Route path="/building-assessment-guide" element={<BasicAssessmentGuide />} />
            <Route path="/advanced-assessment-guide" element={<AdvancedAssessmentGuide />} />
            <Route path="/contact" element={<ContactUs />} />
            <Route path="/bridge-assessment-intro" element={<BasicBridgeLanding />} />
            <Route path="/composite-bridge-assessment" element={<CompositeBridgeAssessment />} />
            <Route path="/masonry-bridge-assessment" element={<MasonryBridgeAssessment />} />
            <Route path="/rcc-bridge-assessment" element={<RCCBridgeAssessment />} />
            <Route path="/psc-bridge-assessment" element={<PSCBridgeAssessment />} />
            <Route path="/steel-bridge-assessment" element={<SteelBridgeAssessment />} />
            <Route path="/tunnel-assessment" element={<TunnelAssessment />} />
            <Route path="/load-bearing-assessment" element={<LoadBearingAssessment />} />
            <Route path="/payment" element={<PaymentPage />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/manage-profile" element={<ManageProfile />} />
            <Route path="/user-reports" element={<UserReports />} />
            <Route path="/admin-login" element={<AdminLogin />} />
            <Route path="/admin-dashboard" element={<AdminDashboard />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
            <Route path="/advanced-rcc-building" element={<AdvancedRCCBuilding />} />
            <Route path="/advanced-rcc-building/:assessmentId" element={<AdvancedRCCBuilding />} />
            <Route path="/advanced-lb-building" element={<AdvancedLBBuilding />} />
            <Route path="/advanced-lb-building/:assessmentId" element={<AdvancedLBBuilding />} />
            <Route path="/advanced-steel-building" element={<AdvancedSteelBuilding />} />
            <Route path="/advanced-steel-building/:assessmentId" element={<AdvancedSteelBuilding />} />
            <Route path="/advanced-composite-building" element={<AdvancedCompositeBuilding />} />
            <Route path="/advanced-composite-building/:assessmentId" element={<AdvancedCompositeBuilding />} />
            <Route path="/advanced-heritage-building" element={<AdvancedHeritageBuilding />} />
            <Route path="/advanced-heritage-building/:assessmentId" element={<AdvancedHeritageBuilding />} />
            <Route path="/assessment-report/:id" element={<AssessmentReport />} />
            <Route path="/expert/physical-inspection" element={<PhysicalInspection />} />
            <Route path="/expert/structural-design-validation" element={<StructuralDesignValidation />} />
            <Route path="/expert/ndt" element={<NDT />} />
            <Route path="/expert/load-test" element={<LoadTest />} />
            <Route path="/expert/shm" element={<SHM />} />
          </Routes>
        </Suspense>
        </main>
      </div>
    </Router>
  );
}

export default App;
